import s from './Card.module.css'

type Props = {
  children: React.ReactNode
  className?: string
}

export const Card = ({ children, className }: Props) => {
  return <div className={`${s.card} ${className}`}>{children}</div>
}
